import script from "./orderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDetail.vue?vue&type=script&setup=true&lang=js"

import "./orderDetail.vue?vue&type=style&index=0&id=45f8639c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f8639c"]])

export default __exports__